// @mui
import { GlobalStyles as MUIGlobalStyles, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        ':root': {
          // CSS Variables for Gradients
          '--gradient-primary': 'linear-gradient(135deg, #A8469B 0%, #569cd3 100%)',
          '--gradient-primary-reverse': 'linear-gradient(135deg, #569cd3 0%, #A8469B 100%)',
          '--gradient-success': 'linear-gradient(135deg, #AAF27F 0%, #54D62C 100%)',
          '--gradient-info': 'linear-gradient(135deg, #74CAFF 0%, #1890FF 100%)',
          '--gradient-warning': 'linear-gradient(135deg, #FFE16A 0%, #FFC107 100%)',
          '--gradient-error': 'linear-gradient(135deg, #FFA48D 0%, #FF4842 100%)',
          
          // Color Variables
          '--color-primary': '#569cd3',
          '--color-primary-dark': '#3A7BA8',
          '--color-purple': '#A8469B',
          '--color-success': '#54D62C',
          '--color-warning': '#FFC107',
          '--color-error': '#FF4842',
        },
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        // Custom Scrollbar Styling - Theme aware
        '*::-webkit-scrollbar': {
          width: 8,
          height: 8,
        },
        '*::-webkit-scrollbar-track': {
          background: isDark ? '#2A2A2A' : '#f1f1f1',
          borderRadius: 4,
        },
        '*::-webkit-scrollbar-thumb': {
          background: isDark ? '#555' : '#888',
          borderRadius: 4,
          '&:hover': {
            background: isDark ? '#777' : '#555',
          },
        },
        // Smooth scrolling
        '@supports (scrollbar-color: auto)': {
          '*': {
            scrollbarColor: isDark ? '#555 #2A2A2A' : '#888 #f1f1f1',
            scrollbarWidth: 'thin',
          },
        },
        // Keyframe animations for gradients and effects
        '@keyframes float': {
          '0%, 100%': {
            transform: 'translateY(0px)',
          },
          '50%': {
            transform: 'translateY(-10px)',
          },
        },
        '@keyframes shimmer': {
          '0%': {
            backgroundPosition: '200% center',
          },
          '100%': {
            backgroundPosition: '-200% center',
          },
        },
        '@keyframes pulse-glow': {
          '0%, 100%': {
            opacity: 1,
          },
          '50%': {
            opacity: 0.7,
          },
        },
        '@keyframes gradient-shift': {
          '0%': {
            backgroundPosition: '0% 50%',
          },
          '50%': {
            backgroundPosition: '100% 50%',
          },
          '100%': {
            backgroundPosition: '0% 50%',
          },
        },
        // Utility classes for quick use
        '.gradient-primary': {
          background: 'var(--gradient-primary)',
        },
        '.gradient-text': {
          background: 'var(--gradient-primary)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        },
        '.glass-effect': {
          background: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(255, 255, 255, 0.2)',
        },
      }}
    />
  );

  return inputGlobalStyles;
}
